// Compiled at 2026-10-07T06:21:14.844Z
// Auto-generated by Lowgile
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Toolbox, Toolbox as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
import { BoInfoSymbol, OnAfterCodeLoad, HasChangedInternallySymbol } from "@lg/shared";
// Auto-generated by Lowgile
import { jsonClass, jsonProperty } from "@sumbricht/json-class-serializer";
import { proxySignal, ProxySignal, signal, computed, Signal } from "../../signals.js";
import { HasSignalProperties } from "@lg/shared";
import { immerable } from "immer";
import { DataLoader } from "@lg/shared";
import { Subject } from "rxjs";
import { z } from "zod";
import { AppContext } from "@lg/ng-shared";
import { ChangeDetectorRef } from "@angular/core";

const θdataLoader =
    new DataLoader(() => GoalSettingViewMode.loadInternal(), entryList => {
        GoalSettingViewMode.θentryList.set(entryList)
        GoalSettingViewMode.θonEntryListUpdated()
    }, { doCache: true, expireAfterMs: 0 })
    ;

// Auto-generated by Lowgile
export class GoalSettingViewMode {
    readonly [BoInfoSymbol] = Object.freeze({
        boType: "StaticEntity" as const,
        editablePropertyNames: ["id"] as const,
        computedPropertyNames: ["label"] as const,
        allPropertyNames: ["id", "label"] as const,
        propertyNamesOfInterest: [] as const,
    });
    readonly [HasSignalProperties] = true;
    readonly [HasChangedInternallySymbol] = new Subject<void>();
    readonly θid: ProxySignal<GoalSettingViewMode.Id | null>;
    static readonly Id = String;
    static ids: GoalSettingViewMode.Id[] = [] as any;
    static idsAndDisplayValues: Record<GoalSettingViewMode.Id, string> = {} as any;
    static θentryList = signal<GoalSettingViewMode.Entry[] | undefined>(this.θgetStaticEntryList());
    static θentryMap = computed(() => {
        const objEntries = this.θentryList()?.map(e => [e.id, e]) ?? []
        return Object.freeze(Object.fromEntries(objEntries))
    });
    static θchoicesCache = new Map<string, Sys.Types.Choice[]>();
    static θfilteredCache = new Map<string, Signal<GoalSettingViewMode.Entry[]>>();
    readonly θhasOthers = false;
    static readonly $displayProperty = 'label';
    [immerable] = true;
    readonly θlabel = computed(() => {
        const id = this.θid()
        return id !== null ? GoalSettingViewMode.getEntryMap()[id]?.label : undefined
    });
    readonly $isOther = false;

    static get [BoInfoSymbol]() {
        return GoalSettingViewMode[BoInfoSymbol]
    }

    get __type(): 'Toolbox.GoalSettingViewMode' {
        return 'Toolbox.GoalSettingViewMode'
    }

    set __type(_) {
    }

    static get __type(): 'Toolbox.GoalSettingViewMode' {
        return 'Toolbox.GoalSettingViewMode'
    }

    static set __type(_) {
    }

    @jsonProperty()
    get id(): GoalSettingViewMode.Id | null {
        return this.θid()
    }

    set id(id: GoalSettingViewMode.Id | GoalSettingViewMode | null) {
        if (id !== null && typeof id == 'object') { id = id.id }

        if (id != null && !GoalSettingViewMode.getEntry(id as GoalSettingViewMode.Id)) throw new Error('Invalid id for type Toolbox.GoalSettingViewMode: ' + id)
        this.θid.set(id as GoalSettingViewMode.Id | null)
        this[HasChangedInternallySymbol].next()
    }

    get __boType(): 'StaticEntity' {
        return 'StaticEntity'
    }

    static get __boType(): 'StaticEntity' {
        return 'StaticEntity'
    }

    get ids(): GoalSettingViewMode.Id[] {
        return GoalSettingViewMode.ids
    }

    get idsAndDisplayValues(): Record<GoalSettingViewMode.Id, string> {
        return GoalSettingViewMode.idsAndDisplayValues
    }

    get $displayValue(): string {
        return this.$isOther ? (this as any).$other : String((this as any)[GoalSettingViewMode.$displayProperty])
    }

    get label() {
        return this.θlabel()
    }

    get isEmployee() {
        return this.id == 'employee'
    }

    static get Employee() {
        return new this('employee')
    }

    get isManager() {
        return this.id == 'manager'
    }

    static get Manager() {
        return new this('manager')
    }

    get isHr() {
        return this.id == 'hr'
    }

    static get Hr() {
        return new this('hr')
    }

    constructor(idOrObject: GoalSettingViewMode.Id | GoalSettingViewMode | null = null) {
        const { id } = this.θtoIdAndOther(idOrObject)
        this.θid = proxySignal(id)

    }

    getEntryList(filters?: { entryProperty: string, values: any[] }[]): GoalSettingViewMode.Entry[] {
        return This.GoalSettingViewMode.getEntryList(filters)
    }

    static getEntryList(filters?: { entryProperty: string, values: any[] }[]): GoalSettingViewMode.Entry[] {
        if (filters) {
            const key = JSON.stringify(filters)
            let filteredList = this.θfilteredCache.get(key)
            if (!filteredList) {
                filteredList = computed(() => this.θentryList()?.filter(entry => filters.every(filter => filter.values.includes(entry[filter.entryProperty]))) ?? [])
                this.θfilteredCache.set(key, filteredList)
            }

            return filteredList()
        }

        return this.θentryList()
    }

    static getEntryMap() {
        return this.θentryMap()
    }

    static getEntry(id: GoalSettingViewMode.Id) {
        const entryMap = this.getEntryMap()
        return entryMap[id]
    }

    static getChoices(labelColumn: keyof GoalSettingViewMode.Entry = '$displayValue'): Sys.Types.Choice[] {
        if (labelColumn == "$displayValue") labelColumn = GoalSettingViewMode.$displayProperty
        let options = this.θchoicesCache.get(labelColumn)
        if (!options) {
            const entryList = this.getEntryList() ?? []
            options = entryList.map(entry => ({ id: entry.id, label: String(entry[labelColumn]), $isOther: false }))
            this.θchoicesCache.set(labelColumn, options)
        }

        return options
    }

    static async load(forceReload = false) {
        if (forceReload) {
            this.θentryList.set(await θdataLoader.forceReloadAndGetData())
        } else {
            this.θentryList.set(await θdataLoader.waitAndGetValidData())
        }

        this.θonEntryListUpdated()
        return this.θentryList()
    }

    static async loadInternal(): Promise<GoalSettingViewMode.Entry[]> {
        const dynamicEntryList = []
        this.θchoicesCache.clear()
        return LowgileDataUtil.createReadonlyProxy(true, [...this.θgetStaticEntryList(), ...dynamicEntryList])
    }

    toJSON() {
        return this.id
    }

    $clone() {
        return new GoalSettingViewMode(this.id)
    }

    $equals(other: any) {
        if (this.id !== other?.id) return false

        return true
    }

    θtoPlainObject() {
        return this.id
    }

    θtoIdAndOther(idOrObject: GoalSettingViewMode.Id | GoalSettingViewMode | null) {
        if (idOrObject && typeof idOrObject == 'object') {
            return { id: idOrObject.id }

        } else {
            return { id: idOrObject as GoalSettingViewMode.Id | null, otherValue: '' }

        }
    }

    θupdate(idOrObject: GoalSettingViewMode.Id | GoalSettingViewMode) {
        const { id } = this.θtoIdAndOther(idOrObject)
        this.θid.set(id)

    }

    static θonEntryListUpdated() {
        this.ids = this.getEntryList().map(e => e.id)
        this.idsAndDisplayValues = Object.fromEntries(this.getEntryList().map(e => [e.id, e.$displayValue] as const)) as Record<GoalSettingViewMode.Id, string>
        AppContext.resolve(ChangeDetectorRef).detectChanges()
    }

    static async θafterCodeLoad() {
        return this.load().catch(err => {
            console.log('Could not load entries of StaticEntity Toolbox.GoalSettingViewMode yet:', err.message)
            //throw err
        })
    }

    static $getSchema() {
        return z.string()
    }

    $getSchema() {
        return z.string()
    }

    setEmployee() {
        this.id = 'employee'

    }

    setManager() {
        this.id = 'manager'

    }

    setHr() {
        this.id = 'hr'

    }

    static θgetStaticEntryList() {
        return Object.freeze([
            Object.freeze({ id: "employee", label: "Employee" }),
            Object.freeze({ id: "manager", label: "Manager" }),
            Object.freeze({ id: "hr", label: "HR" })
        ] as GoalSettingViewMode.Entry[]) as GoalSettingViewMode.Entry[]
    }
}
jsonClass('Toolbox.GoalSettingViewMode')(GoalSettingViewMode)

export const GoalSettingViewModeθId = String;

export type GoalSettingViewModeθId = string;

export namespace GoalSettingViewMode {
    export type Id = 'employee' | 'manager' | 'hr'

    export interface Entry {
        id: GoalSettingViewMode.Id;
        label: string;
        $displayValue?: string;
    }
}
Sys.Language.languageChanged$.subscribe(() => GoalSettingViewMode.load(true))
